<template>
  <div class="d-block">
    <div id="contact-container">
      <p>
        <span>
          {{ $t('global-need-help') }}
        </span>
        <parent-reference-line-item-id class="mt-2" />
      </p>
      <p
        class="contact-list"
        v-html="$t('contact')"
      />
    </div>
    <back-button />
  </div>
</template>

<script>
import BackButton from './BackButton'
import ParentReferenceLineItemId from '@/components/shared/ParentReferenceLineItemId'

export default {
  name: 'ContactUs',
  components: { BackButton, ParentReferenceLineItemId }
}
</script>

<style lang="scss">
@import '../../assets/css/variables';
@import 'src/scss/variables';

#contact-container {
  padding-top: 72px;
  line-height: 1.2em;
  font-size: 18px;
  color: $tangoTextPrimary;

  a {
    &:visited,
    &:link,
    &:active {
      font-weight: bold;
    }
  }

  a.tel {
    &:visited,
    &:link,
    &:active,
    &:hover {
      font-weight: bold;
      text-decoration: none;
      color: $tangoTextPrimary;
    }
  }

  .contact-list {
    line-height: 1.8em;
  }
}

@media screen and (max-width: $breakpoint-md - 1) {
  #contact-container {
    padding-top: 22px;
  }
}
</style>
